export default "<div>\n  {{CategorieDocumentInComponent?.Identifiant}}\n</div>\n";